// extracted by mini-css-extract-plugin
module.exports = {"yogaBootcampPage":"YogaBootcampPage_yogaBootcampPage__01Kr3","certifiedInstructors":"YogaBootcampPage_certifiedInstructors__3s6zX"};